import { render, staticRenderFns } from "./ChevronGrabberIcon.vue?vue&type=template&id=6e2cfbde&scoped=true"
import script from "./ChevronGrabberIcon.vue?vue&type=script&lang=js"
export * from "./ChevronGrabberIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2cfbde",
  null
  
)

export default component.exports